var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFormfn = function SvgFormfn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Formfn_svg__a)",
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.727 11C11.564 11 9 13.513 9 16.613v12.163c0 .123.103.224.23.224h.152c3.163 0 5.727-2.513 5.727-5.613V11.225A.227.227 0 0 0 14.88 11h-.153Zm7.446 0c-3.163 0-5.728 2.513-5.728 5.613v12.163c0 .123.103.224.23.224h.152c3.163 0 5.727-2.513 5.727-5.613V11.225a.227.227 0 0 0-.229-.225h-.152Zm1.718.45c0-.213 0-.318.067-.384s.175-.066.391-.066h5.193c.216 0 .324 0 .39.066.068.066.068.171.068.383v5.09c0 .211 0 .317-.067.383s-.175.066-.391.066h-5.193c-.216 0-.324 0-.391-.066s-.067-.172-.067-.384V11.45Zm3.054 6.847c-1.686 0-3.054 1.34-3.054 2.994 0 1.654 1.368 2.994 3.054 2.994 1.687 0 3.055-1.34 3.055-2.994 0-1.653-1.368-2.994-3.055-2.994Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Formfn_svg__a",
    x1: 0,
    x2: 42,
    y1: 6.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3787FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4E48F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8458FF"
  })))));
};
export default SvgFormfn;